import {visit} from 'unist-util-visit';
import type {Parent, Root, Text, Image} from 'mdast';

export function transformGoBoardThumbnails(): (tree: Root) => void {
    return (tree: Root) => {
        visit(tree, 'text', (node: Text, index, parent) => {
            if (!parent || index === undefined) return;

            const regex = /\[diagram:sgf=\(/g;
            const segments: (Text | Image)[] = [];
            let lastIndex = 0;
            let match;

            while ((match = regex.exec(node.value)) !== null) {
                const start = match.index;
                const openParenIndex = node.value.indexOf('(', start);
                if (openParenIndex === -1) continue;

                let depth = 0;
                let endParenIndex = -1;
                for (let i = openParenIndex; i < node.value.length; i++) {
                    const char = node.value[i];
                    if (char === '(') depth++;
                    else if (char === ')') depth--;
                    if (depth === 0) {
                        endParenIndex = i;
                        break;
                    }
                }

                if (endParenIndex === -1) continue;

                const sgf = node.value.slice(openParenIndex, endParenIndex + 1);
                const fullEnd = node.value.lastIndexOf(']');

                if (fullEnd === -1) continue;

                if (start > lastIndex) {
                    segments.push({
                        type: 'text',
                        value: node.value.slice(lastIndex, start),
                    } as Text);
                }

                const paramString = node.value
                    .slice(endParenIndex + 1, fullEnd)
                    .trim();

                const params: Record<string, string> = {};
                paramString.split(/\s+/).forEach((pair: string) => {
                    const eqIndex = pair.indexOf('=');
                    if (eqIndex > 0) {
                        const key = pair.slice(0, eqIndex);
                        const value = pair.slice(eqIndex + 1);
                        params[key] = value;
                    }
                });

                const url = new URL(
                    '/api/v2/tools/sgf/renderext',
                    location.origin
                );

                url.searchParams.set('sgf', sgf);
                for (const [key, value] of Object.entries(params)) {
                    url.searchParams.set(key, value);
                }

                segments.push({
                    type: 'image',
                    url: url.toString(),
                    title: null,
                    alt: 'Go diagram',
                } as Image);

                lastIndex = fullEnd + 1;
                regex.lastIndex = fullEnd + 1;
            }

            if (lastIndex < node.value.length) {
                segments.push({
                    type: 'text',
                    value: node.value.slice(lastIndex),
                } as Text);
            }

            if (segments.length > 0) {
                (parent as Parent).children.splice(index, 1, ...segments);
            }
        });
    };
}
